import { formatEther, getAddress } from "viem";
import type { Hex } from "../services/launcher/types";

/** Wei -> human ETH string, trimmed, with unit. e.g. 10000000000000000n -> "0.01 ETH". */
export function formatEth(wei: bigint, maxFractionDigits = 6): string {
  const s = formatEther(wei);
  const dot = s.indexOf(".");
  if (dot === -1) return `${s} ETH`;
  const int = s.slice(0, dot);
  const frac = s.slice(dot + 1);
  const trimmed = frac.slice(0, maxFractionDigits).replace(/0+$/, "");
  return `${trimmed ? `${int}.${trimmed}` : int} ETH`;
}

/** Checksummed address, or throws for invalid input. */
export function checksum(address: string): Hex {
  return getAddress(address) as Hex;
}

/**
 * Truncate an address for display while keeping enough to recognise it. The full
 * value must remain available for copy elsewhere in the UI (poisoning-resistant).
 */
export function truncateAddress(address: string, lead = 6, tail = 4): string {
  const a = getAddress(address);
  return `${a.slice(0, 2 + lead)}…${a.slice(-tail)}`;
}

/**
 * Truncate any hex string (e.g. a transaction hash) for display without
 * address-length validation. Use for tx hashes and other non-address hex values.
 */
export function truncateHex(hex: string, lead = 6, tail = 4): string {
  return `${hex.slice(0, 2 + lead)}…${hex.slice(-tail)}`;
}

/** Group a whole-token bigint with thin separators for readability. */
export function formatWholeTokens(whole: bigint): string {
  return whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
